import React, { Component } from 'react';
import FAQCategory from '../../../../src/models/FAQCategory';
import FAQCategoryListView from '../views/FAQCategoryListView';
import FAQCategoryView from '../views/FAQCategoryView';

declare var dataLayer: any;

type FAQOverviewPagePageProps = {
    categories: FAQCategory[];
    selectedCategory: FAQCategory;
}

type FAQOverviewPagePageState = {
    selectedCategory: FAQCategory
}

export default class FAQOverviewPage extends Component<FAQOverviewPagePageProps, FAQOverviewPagePageState> {
    constructor(props: FAQOverviewPagePageProps) {
        super(props);
        this.state = {
            selectedCategory: props.selectedCategory
        };

    }

    public selectCategory(category: FAQCategory): void {
        this.setState({
            selectedCategory: category
        })
    }

    public render() {
        return (
            <div className="container mt-5 mb-5">
                <div className="row">
                    <div className="col-lg-3 mb-4">
                        <FAQCategoryListView categories={this.props.categories} selectedCategory={this.state.selectedCategory.id > 0 ? this.state.selectedCategory : this.props.selectedCategory} categorySelected={(category: FAQCategory) => { this.selectCategory(category); }} />
                    </div>
                    <div className="col-lg-1"></div>
                    <div className="col  py-5">
                        <FAQCategoryView category={this.state.selectedCategory.id > 0 ? this.state.selectedCategory : this.props.selectedCategory}></FAQCategoryView>
                    </div>
                    <div className="col-lg-1"></div>
                </div>
            </div>
        );
    }
}